<head>
  <meta http-equiv="Cache-Control" content="no-cache, no-store, must-revalidate" />
  <meta http-equiv="Pragma" content="no-cache" />
  <meta http-equiv="Expires" content="0" />
</head>
<ng-container>
  <div class="container">
    <form [formGroup]="searchForm" novalidate autocomplete="off" >
      <table id="clientinfo" class="table table-striped table-fixed table-sm shadow-1-strong rounded-1 p-1">
        <caption>
          Client and Employment details
        </caption>
        <tbody class="field-4column-label">
          <tr>
            <td>
              <label for="clientStatus">Client Status</label>
            </td>
            <td>{{clientShowModel.clientStatus}}</td>
            <td>
              <label for="loanStatus">Loan Status</label>
            </td>
            <td>{{clientShowModel.loanStatus}}</td>
          </tr>
          <tr>
            <td>
              <label for="fullNames">Full Names</label>
            </td>
            <td>{{clientShowModel.fullNames}}</td>
            <td>
              <label for="surname">Surname</label>
            </td>
            <td>{{clientShowModel.surname}}</td>
          </tr>
          <tr>
            <td>
              <label for="idNumber">ID Number</label>
            </td>
            <td>{{clientShowModel.idNumber}}</td>
            <td>
              <label for="cellNumber">Cell Number</label>
            </td>
            <td>{{clientShowModel.cellNumber}}</td>
          </tr>
          <tr>
            <td>
              <label for="clientType">Client Type/Source of Funds</label>
            </td>
            <td>
              <mdb-select #clientTypeSelect class="select table-control" [formControlName]="'clientType'"
                [mdbPopover]="sassaPopoverTemplate" mdbPopoverTitle="Employment details warning"
                trigger="manual" placement="right"
                aria-role="combobox" aria-disabled="false" required>
                <mdb-option *ngFor="let clientType of lstClientTypes" [value]="clientType.value">
                  {{clientType.description}}
                </mdb-option>
              </mdb-select>
              <div *ngIf="clientType?.invalid">
                <div *ngIf="clientType?.errors?.required && submitted">
                  <small class="text-danger">Client type is required.</small>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <label for="maritalStatus">Marital Status</label>
            </td>
            <td>
              <mdb-select class="select table-control" aria-role="combobox" formControlName="maritalStatus" placeholder="Marital status *" required>
                <mdb-option *ngFor="let marstatus of lstMarStatus" [value]="marstatus.value">
                  {{marstatus.description}}
                </mdb-option>
              </mdb-select>
              <div *ngIf="maritalStatus?.invalid">
                <div *ngIf="maritalStatus?.errors?.required && submitted">
                  <small class="text-danger">Marital status is required.</small>
                </div>
              </div>
            </td>
            <td>
              <label for="nationality">Nationality</label>
            </td>
            <td>
              <mdb-select class="select table-control" aria-role="combobox" formControlName="nationality" (change)="onNationalitySelect($event)"
                [ngClass]="{ 'is-invalid': nationality?.value == 'OTHER' }" required>
                 <mdb-option *ngFor="let nat of lstNAtional" [value]="nat.value">
                  {{nat.description}}
                </mdb-option>
              </mdb-select>
              <div *ngIf="nationality?.invalid">
                <div *ngIf="nationality?.errors?.required && submitted">
                  <small class="text-danger">
                    Only South African nationality is acccepted
                  </small>
                </div>
                <div *ngIf="nationality?.value == 'OTHER' && submitted">
                  <small class="text-danger">
                    Only South African nationality is acccepted
                  </small>
                </div>
              </div>
            </td>
          </tr>
          <!-- Loan Amount -->
          <tr>
            <td>
              <label for="loanAmount">Loan Amount</label>
            </td>
            <td>
              <input class="form-control" formControlName="loanAmount" placeholder="Loan amount *" required
                lmsNumbersOnly [allowDecimals]="false" />
              <div *ngIf="loanAmount?.invalid">
                <div *ngIf="loanAmount?.errors?.required && submitted">
                  <small class="text-danger">Loan amount required.</small>
                </div>
              </div>
            </td>
            <td>
              <label for="loanReason">Loan Reason</label>
            </td>
            <td>
              <mdb-select class="select table-control" formControlName="loanReason"  placeholder="Loan reason *" aria-role="listbox" aria-multiselectable="true"
                aria-disabled="false" [autoSelect]="false">
                <mdb-option  *ngFor="let reason of lstAllLoanReasonCodes" [value]="reason.reasonCode">
                  {{reason.description}}
                </mdb-option>
              </mdb-select>
              <div *ngIf="loanReason?.invalid">
                <div *ngIf="loanReason?.errors?.required && submitted">
                  <small class="text-danger">Loan reason is required.</small>
                </div>
              </div>
            </td>
          </tr>
          <!-- Source of Wealth -->
          <tr>
            <td>
              <label for="sourceOfWealth">Source of Wealth</label>
            </td>
            <td>
              <mdb-select class="select table-control" formControlName="sourceOfWealth"  placeholder="Source of wealth *" aria-role="combobox" aria-multiselectable="false"
                aria-disabled="false" required>
                <mdb-option  *ngFor="let sod of lstSOD" [value]="sod.value">
                  {{sod.description}}
                </mdb-option>
              </mdb-select>
              <div *ngIf="sourceOfWealth?.invalid">
                <div *ngIf="sourceOfWealth?.errors?.required && submitted">
                  <small class="text-danger">Source of wealth is required.</small>
                </div>
              </div>
            </td>
            <td *ngIf="sourceOfWealth?.value == 'Other'">
              <label for="sourceOfWealthOther">Source of Wealth Other</label>
            </td>
            <td *ngIf="sourceOfWealth?.value == 'Other'">
              <div>
                <input class="form-control" formControlName="sourceOfWealthOther" placeholder="Source of Wealth *"
                  lmsNoSpecials [required]="sourceOfWealth?.value == 'Other'" />
              </div>
            </td>
          </tr>
          <!-- Additional Income -->
          <!-- Marketing Options -->
          <tr>
            <td>Marketing Options</td>
            <td colspan="3">
              <span [ngClass]="{ 'is-invalid': marketingOptions?.invalid && submitted }">
              <mdb-select class="select table-control" [formControlName]="'marketingOptions'" placeholder="Marketing options *" aria-role="combobox" multiple aria-multiselectable="true"
                aria-disabled="false" style="max-width: 225px;">
                <mdb-option class="max-width: 100%;" *ngFor="let marketingOption of lstMarketingOptions"
                  [value]="marketingOption.description"
                  [disabled]="((marketingOption.description || '').toLowerCase() !== 'none' && isMONoneSelected) || ((marketingOption.description || '').toLowerCase() !== 'other' && isMAOtherOptionSelected)">
                  {{marketingOption.description}}
                </mdb-option>
              </mdb-select>
              </span>
            </td>
          </tr>
          <tr>
            <td>
              <label>Contact Preference</label>
            </td>
            <td>
              <mdb-select class="select table-control" formControlName="contactPreference" placeholder="Contact Preference"
                aria-role="combobox" aria-multiselectable="false" aria-diabled="false" required [autoSelect]="false">
                 <mdb-option  *ngFor="let contPref of lstContactPref" [value]="contPref.value">
                  {{contPref.description}}
                </mdb-option>
              </mdb-select>
              <div *ngIf="contactPreference?.invalid && submitted">
                <div *ngIf="contactPreference?.errors?.required && contactPreference?.touched && contactPreference?.dirty">
                  <small class="text-danger">Contact preference is required.</small>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <div *ngIf="ClientTypeSASSA; then showsassa else showsalaried"></div>
              <ng-template #showsassa>
                <!-- Type of grant -->
                <app-sassa-editor [sallabel]="preAuthorisationModel.clientType" controlKey="sassaTypeControls"
                  [Submitted]="submitted" [preauthModel]="preAuthorisationModel"></app-sassa-editor>
              </ng-template>
              <ng-template #showsalaried>
                <app-salaried-editor [sallabel]="preAuthorisationModel.clientType" controlKey="salariedTypeControls"
                  [Submitted]="submitted" [preauthModel]="preAuthorisationModel" (paySlipCaptured)="onPayslipCaptured($event)" (payslipsUpdated)="onPayslipsUpdated($event)"></app-salaried-editor>
              </ng-template>
            </td>
          </tr>
        </tbody>
      </table>

      <ng-container *ngIf="compuscanOffersEvery">
        <div class="note note-warning d-flex py-3">
          <span>
            <div class="fw-bold">
              No valid Codix offers available
            </div>
            No valid Codix offers were found for this customer.
            Please note that NO offers will be available for
            selection, if you continue.
          </span>
        </div>
      </ng-container>
      <!-- ==   =============   Listing Questions ============= -->
        <table id="questions"
        class="table table-fixed table-bordered table-hover table-sm  shadow-1-strong rounded-1 p-1">
        <caption>
          Listing Questions
        </caption>
        <colgroup>
          <col style="width: 70%;">
          <col style="width: 30%;">
        </colgroup>
        <tbody>
          <tr>
            <td>
              Are you subject to an administration order?
              <div *ngIf="underAdministration?.invalid && submitted">
                <div *ngIf="underAdministration?.errors?.required">
                  <small class="text-danger">
                    Under administration option is required.
                  </small>
                </div>
              </div>
              <div *ngIf="underAdministration?.value == 'yes'">
                <small class="text-danger">
                  The client will not qualify for a loan, if subject to an
                  administration order.
                </small>
              </div>
            </td>
            <td>
              <div class="radio-group-validation" role="radiogroup" aria-label="Under administration">
                <div class="form-check mb-0">
                  <input mdbRadio class="form-check-input" type="radio" name="underAdministration" id="underAdminYes" value="yes" formControlName="underAdministration" required />
                  <label class="form-check-label" for="underAdminYes">Yes</label>
                </div>
                <div class="form-check mb-0">
                  <input mdbRadio class="form-check-input" type="radio" name="underAdministration" id="underAdminNo" value="no" formControlName="underAdministration" required />
                  <label class="form-check-label" for="underAdminNo">No</label>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              Are you currently under sequestration?
              <div *ngIf="underSequestration?.invalid && submitted">
                <div *ngIf="underSequestration?.errors?.required">
                  <small class="text-danger">Under sequestration option is required.</small>
                </div>
              </div>
              <div *ngIf="underSequestration?.value == 'yes'">
                <small class="text-danger">
                  The client will not qualify for a loan, if currently under
                  sequestration.
                </small>
              </div>
            </td>
            <td>
              <div class="radio-group-validation" role="radiogroup" aria-label="Under sequestration">
                <div class="form-check">
                  <input mdbRadio class="form-check-input" type="radio" name="underSequestration" id="underSeqYes" value="yes" formControlName="underSequestration" required />
                  <label class="form-check-label" for="underSeqYes">Yes</label>
                </div>
                <div class="form-check">
                  <input mdbRadio class="form-check-input" type="radio" name="underSequestration" id="underSeqNo" value="no" formControlName="underSequestration" required />
                  <label class="form-check-label" for="underSeqNo">No</label>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              Are you under debt review or of the intention to apply for debt review?
              <div *ngIf="underDebtReview?.invalid && submitted">
                <div *ngIf="underDebtReview?.errors?.required">
                  <small class="text-danger">Under debt review option is required.</small>
                </div>
              </div>
              <div *ngIf="underDebtReview?.value=='yes'">
                <small class="text-danger">
                  The client will not qualify for a loan, if currently under
                  debt review.
                </small>
              </div>
            </td>
            <td>
              <div class="radio-group-validation" role="radiogroup" aria-label="Under debt review">
                <div class="form-check">
                  <input mdbRadio class="form-check-input" type="radio" name="underDebtReview" id="underDebtYes" value="yes" formControlName="underDebtReview" required />
                  <label class="form-check-label" for="underDebtYes">Yes</label>
                </div>
                <div class="form-check">
                  <input mdbRadio class="form-check-input" type="radio" name="underDebtReview" id="underDebtNo" value="no" formControlName="underDebtReview" required />
                  <label class="form-check-label" for="underDebtNo">No</label>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="flex-container flex-nowrap">
        <button class="btn btn-primary" mdbRipple type="button" (click)="openRejectOfferDialog()">
          <i class="fas fa-fw fa-xmarks-lines me-1"></i>
          Reject offer
        </button>
        <button class="btn btn-primary" mdbRipple type="button" (click)="valuesDialog()">
          <i class="fas fa-cart-shopping fa-fw me-1"></i>
          View Codix offers
        </button>
        <button class="btn btn-primary" mdbRipple type="button"
          (click)="lmsDialogHandler.openClientDocuments(clientShowModel)">
          <i class="fas fa-file-invoice fa-fw me-1"></i>
          Client Documents
        </button>
        <button class="btn btn-primary ms-4" mdbRipple type="button"
          (dblclick)="global_utility.findInvalidControls(searchForm)" (click)="submitClientSearch()"> Submit
        </button>
      </div>
    </form>
    <!-- SASSA Employment Info Popover Template -->
    <ng-template #sassaPopoverTemplate>
      <div class="risk-summary-hover">
        <div class="risk-summary-content">
          <div class="risk-popover-content">

            <div class="p-1 sassa-popover-container">
              <div class="alert alert-warning mx-1 text-wrap sassa-popover-alert" role="alert">
                <h5>Warning:</h5><label class="text-center">Changing client type to {{ sassaEmploymentInfo?.newClientType }}, will reset employer information. <br/> If this is incorrect, You will need to re-capture the employment information.</label>
              </div>

              <h6 class="mb-3" style="text-align: center !important;"><strong>Current Employment Details:</strong></h6>
              <dl class="row small ms-3">
                <dt class="col-6">Current Employer</dt>
                <dd class="col-6">{{ sassaEmploymentInfo?.employerName || '-' }}</dd>

                <dt class="col-6">Employment Type</dt>
                <dd class="col-6">{{ sassaEmploymentInfo?.employmentType || '-' }}</dd>

                <dt class="col-6">Pay Date</dt>
                <dd class="col-6">{{ sassaEmploymentInfo?.payDate || '-' }}</dd>

                <dt class="col-6">Wage Calendar</dt>
                <dd class="col-6">{{ sassaEmploymentInfo?.wageCalendar || '-' }}</dd>

                <dt class="col-6">Occupation</dt>
                <dd class="col-6">{{ sassaEmploymentInfo?.occupation || '-' }}</dd>

                <dt class="col-6">Additional Income</dt>
                <dd class="col-6">{{ sassaEmploymentInfo?.selectedadditionalIncome || '-' }}</dd>
              </dl>
                <div class="sassa-popover-actions">
                  <button type="button" class="btn btn-primary" (click)="closeSassaPopover(false)">Cancel</button>
                  <button type="button" class="btn btn-primary" (click)="closeSassaPopover(true)">I Understand</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <!-- Backdrop for popover -->
    <div *ngIf="showBackdrop"
        class="popover-backdrop"
        style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5); z-index: 1050; cursor: pointer;">
    </div>
  </div>
</ng-container>
